import t from 'react-translate';
import { map } from 'underscore';
import { css } from '@emotion/react';

import { halfSpacing, standardSpacing } from 'styles/global_defaults/scaffolding';
import { NovoAIItemType } from 'redux/schemas/models/lecture-page';
import AIComponentCard from './ai-components-card';

const styles = css`
  & {
    gap: ${halfSpacing}px;
  }

  .item-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: ${standardSpacing}px;
  }
`;


const AIComponentsList = () => (
  <div className='d-flex flex-column w-100' css={styles}>
    <div className='text-body text-center'>
      {t.LECTURE_PAGES.LHS.NOVO_AI.COMPONENT_LIST_TITLE()}
    </div>
    <div className='item-grid'>
      {map(NovoAIItemType, (type) => (
        <AIComponentCard type={type} key={type} />
      ))}
    </div>
  </div>
);

export default AIComponentsList;
